'use client';

import { c as _c } from "react/compiler-runtime";
import { Image } from '@petsmart-ui/sparky';
import { useState } from 'react';
import { getENV } from '../../utils/env';
import { buildScene7StaticId, getScene7StaticUrl } from '../../utils/scene7Static';
export interface Scene7ImageProps {
  src: string;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  loading?: 'eager' | 'lazy';
  scene7Query?: string;
  testId?: string;
}
export function Scene7Image(props) {
  const $ = _c(27);
  const {
    src,
    alt,
    className,
    width,
    height,
    loading: t0,
    scene7Query,
    testId
  } = props;
  const loading = t0 === undefined ? "lazy" : t0;
  let t1;
  if ($[0] !== src) {
    t1 = src.toLowerCase().endsWith(".svg") || src.toLowerCase().endsWith(".gif");
    $[0] = src;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const skipAsset = t1;
  let t2;
  if ($[2] !== skipAsset || $[3] !== src) {
    t2 = skipAsset ? src : getScene7StaticUrl(buildScene7StaticId(src));
    $[2] = skipAsset;
    $[3] = src;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const candidateBase = t2;
  const candidate = scene7Query && !skipAsset ? `${candidateBase}?${scene7Query}` : candidateBase;
  const [useFallback, setUseFallback] = useState(false);
  let t3;
  if ($[5] !== candidate || $[6] !== src || $[7] !== useFallback) {
    t3 = useFallback ? `/${getENV("NEXT_PUBLIC_APP_NAME")}${src}` : candidate;
    $[5] = candidate;
    $[6] = src;
    $[7] = useFallback;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const displaySrc = t3;
  const preloadHref = loading === "eager" ? displaySrc : undefined;
  let t4;
  if ($[9] !== candidate || $[10] !== src || $[11] !== useFallback) {
    t4 = () => {
      if (!useFallback && candidate !== src) {
        setUseFallback(true);
      }
    };
    $[9] = candidate;
    $[10] = src;
    $[11] = useFallback;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleError = t4;
  let t5;
  if ($[13] !== preloadHref) {
    t5 = preloadHref && <link rel="preload" href={preloadHref} as="image" />;
    $[13] = preloadHref;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== alt || $[16] !== className || $[17] !== displaySrc || $[18] !== handleError || $[19] !== height || $[20] !== loading || $[21] !== testId || $[22] !== width) {
    t6 = <Image data-testid={testId} src={displaySrc} alt={alt} className={className} width={width} height={height} loading={loading} onError={handleError} />;
    $[15] = alt;
    $[16] = className;
    $[17] = displaySrc;
    $[18] = handleError;
    $[19] = height;
    $[20] = loading;
    $[21] = testId;
    $[22] = width;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t5 || $[25] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}